var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 27,
    viewBox: "0 0 24 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8556 7.65999C16.8556 10.946 14.5267 13.3931 11.9053 13.3931C9.28396 13.3931 6.95507 10.946 6.95507 7.65999C6.95507 4.37394 9.28396 1.92688 11.9053 1.92688C14.5267 1.92688 16.8556 4.37394 16.8556 7.65999Z",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.08016 15.2347C8.08016 15.2347 4.25499 16.4972 2.55491 17.7597C0.854836 19.0221 0.850953 20.1731 1.70487 23.2303C2.5588 26.2875 20.8344 26.5483 21.6808 23.2303C22.5272 19.9124 22.9558 19.0221 21.2558 17.7597C19.5557 16.4972 15.3055 15.2347 15.3055 15.2347",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_37_410",
    x1: 0.908875,
    y1: 1.92688,
    x2: 25.6822,
    y2: 2.19231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792,
    stopColor: "#142FCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B406B8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.5e021dfabefbf2245aa64c08da6719f3.svg";
export { ForwardRef as ReactComponent };